<app-global-loader></app-global-loader>

<main class="invoice">
  <router-outlet></router-outlet>
</main>
